@if (showHTXOnly()) {
  <div class="logo-htx-only" [style.width]="width()">
    <img
      src="/assets/images/htx-logo.png"
      [alt]="alt()"
      (click)="onClick()"
      class="logo-image"
    />
  </div>
} @else {
  <img
    src="/assets/images/htx-logo.png"
    [alt]="alt()"
    [style.width]="width()"
    (click)="onClick()"
    class="logo-image"
  />
}
